/*=========================================================================================
  File Name: moduleEcommerceState.js
  Description: Ecommerce Module State
  ----------------------------------------------------------------------------------------
  Lighthouse - Cloudify Admin Panel
==========================================================================================*/

/* eslint-disable */
export default {
    cartItems: [],
    wishList: []
}
/* eslint-enable */
